<script setup>
import { useI18n } from '../i18n'
const { t } = useI18n()
</script>

<template>
  <section class="access-empty no-access-page">
    <p class="eyebrow">{{ t('access') }}</p>
    <h1>{{ t('noAccessibleModules') }}</h1>
    <p>{{ t('noAccessibleModulesHint') }}</p>
  </section>
</template>
